module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.doCover) ? _c('div', {
    staticClass: "cover-layer"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice-container"
  }, [_vm._v("如需在手机上查看数据"), _c('br'), _vm._v("建议您登录电脑升级为付费版")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3bd2da86", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3bd2da86!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmCover.vue
// module id = 840
// module chunks = 0